import Query from '../../../components/Report';

export const query = () => new Query('search-summary-anonymized');
